import React from "react";
import { rgba } from "polished";
import styled, { css } from "styled-components";
var ArrowSvg = function ArrowSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9 0 7.414 1.586l6.277 6.289H0v2.25h13.691l-6.277 6.289L9 18l9-9-9-9Z"
  }));
};
ArrowSvg.defaultProps = {
  width: "18",
  height: "18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var CaretDownSvg = function CaretDownSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.406 5.784.246 1.258a.675.675 0 0 1 0-1.042.926.926 0 0 1 1.189 0L6 4.22 10.565.216a.926.926 0 0 1 1.189 0 .675.675 0 0 1 0 1.042l-5.16 4.526A.9.9 0 0 1 6 6a.901.901 0 0 1-.594-.216Z"
  }));
};
CaretDownSvg.defaultProps = {
  width: "12",
  height: "6",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import breakpoint from "../../../utils/breakpoint";
import getBorderRadius from "../../../utils/getBorderRadius";
import getColor from "../../../utils/getColor";
import getTextColor from "../../../utils/getTextColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import FlexContainerOrg from "../../organisms/FlexContainerOrg";
export var HeaderWrapper = styled.div.withConfig({
  componentId: "sc-5r0vlf-0"
})(["display:flex;position:relative;align-items:center;justify-content:space-between;padding:", ";", "{padding:", ";cursor:pointer;}"], space(3), breakpoint("small", "large"), space(2));
export var MobileArrowIconWrapper = styled.div.withConfig({
  componentId: "sc-5r0vlf-1"
})(["display:none;", "{display:inline-block;}"], breakpoint("small", "large"));
export var FooterWrapper = styled.div.withConfig({
  componentId: "sc-5r0vlf-2"
})(["padding:", ";", "{padding:", ";}"], space(3), breakpoint("small", "large"), space(2));
export var ButtonsWrapper = styled.div.withConfig({
  componentId: "sc-5r0vlf-3"
})(["transition:opacity 0.4s 0.1s;opacity:0;", "{opacity:1;}"], breakpoint("small", "large"));
export var ArrowIconWrapper = styled.div.withConfig({
  componentId: "sc-5r0vlf-4"
})(["position:absolute;bottom:", ";left:", ";width:100%;transform:translateX(0);transition:transform 0.7s,opacity 0.4s;", "{display:none;}"], unit(3), unit(3), breakpoint("small", "large"));
export var HoverWrapperStyles = function HoverWrapperStyles() {
  return css(["", "{transform:translateX(150%);opacity:0;}", "{opacity:1;}"], ArrowIconWrapper, ButtonsWrapper);
};
export var StyledFlexContainerOrg = styled(FlexContainerOrg).withConfig({
  componentId: "sc-5r0vlf-5"
})(["height:100%;"]);
export var Wrapper = styled.div.withConfig({
  componentId: "sc-5r0vlf-6"
})(function (_ref) {
  var $isOpen = _ref.$isOpen,
    $isActive = _ref.$isActive,
    $backgroundColor = _ref.$backgroundColor,
    theme = _ref.theme;
  return css(["display:inline-block;overflow:hidden;border-radius:", ";background:", ";", "{", " &:hover{background:", ";}}", "{display:block;", "}"], getBorderRadius(theme, "large"), rgba(getColor(theme, $backgroundColor), 0.8), breakpoint("large"), $isActive ? css(["", ""], HoverWrapperStyles()) : css(["&:hover{", "}"], HoverWrapperStyles()), rgba(getColor(theme, $backgroundColor), 1), breakpoint("small", "large"), $isOpen && css(["background:", ";", "{transform:rotate(180deg);}"], rgba(getColor(theme, $backgroundColor), 0.8), MobileArrowIconWrapper));
});
export var StyledArrowSvg = styled(ArrowSvg).withConfig({
  componentId: "sc-5r0vlf-7"
})(function (_ref2) {
  var theme = _ref2.theme,
    $onColor = _ref2.$onColor;
  return css(["fill:", ";"], getTextColor(theme, $onColor));
});
export var StyledCaretDownSvg = styled(CaretDownSvg).withConfig({
  componentId: "sc-5r0vlf-8"
})(function (_ref3) {
  var theme = _ref3.theme,
    $onColor = _ref3.$onColor;
  return css(["fill:", ";"], getTextColor(theme, $onColor));
});